import { Form, useFormContext } from "@/components/form";
import { Dialog, Drawer, ModalHeader, useOpenModal } from "@/components/modal";
import { getAllRubros } from "@/features/auxiliar/rubros/api/get-all-rubros";
import { getRubro } from "@/features/auxiliar/rubros/api/get-rubro";
import { Stack, Typography } from "@mui/material";
import ArticuloGeneralInfoAdditionalDataForm, { additionalArticuloDataSchema } from "./articulo-general-info-additional-data-form";
import AddIcon from '@mui/icons-material/Add';
import { AddRubroMutation } from "@/features/auxiliar/rubros/api/add-rubro";
import RubroForm, { rubroFormSchema } from "@/features/auxiliar/rubros/components/rubro-form";
import { notify } from "@/shared/notification";
import { SchemaFormHook } from "@/components/form";

export default function ArticuloGeneralInfoFormFields() {
    const openModal = useOpenModal();

    const form = useFormContext();

    return <Stack gap={2}>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Typography variant="h6">Información General</Typography>
            <form.Subscribe selector={({ values }) => [values.numeroItem, values.cantidadMinima, values.cantidadPorCaja]}>
                {(list) => {
                    const count = Array.from(list).filter(v => Boolean(v)).length;
                    return <Form.Button size="small" variant="outlined" onClick={() => openModal("additionalData")}>
                        Datos Adicionales {count > 0 && <>({count})</>}
                    </Form.Button>
                }}
            </form.Subscribe>
        </Stack>
        <Form.TextField name="nombre" label="Nombre" size="small" />
        <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
            <Stack flex={"1 1 160px"}>
                <Form.TextField name="codigo" label="Código" size="small" />
            </Stack>
            <Stack direction={"row"} gap={1} flex={"1 1 160px"}>
                <Stack flex={1}>
                    <Form.ModelComboBox name="rubroId" label="Rubro" size="small" get={getRubro} getAll={getAllRubros} />
                </Stack>
                <Form.IconButton onClick={() => openModal("addRubro")}>
                    <AddIcon />
                </Form.IconButton>
            </Stack>
        </Stack>
        <Form.TextField name="descripcion" label="Descripción" multiline rows={4} size="small" />

        <Dialog code="additionalData" size="xs">
            <ModalHeader>Datos Adicionales</ModalHeader>
            <form.Subscribe selector={({ values }) => [values.numeroItem, values.cantidadMinima, values.cantidadPorCaja]}>
                {([numeroItem, cantidadMinima, cantidadPorCaja]) => <SchemaFormHook
                    schema={additionalArticuloDataSchema}
                    onSubmit={({ value }) => Object.entries(value).forEach(([name, value]) => form.setFieldValue(name, value))}
                    defaultValues={{ numeroItem, cantidadMinima, cantidadPorCaja }}
                    closeModalOnSubmit
                    submitOnce
                >
                    {form => <ArticuloGeneralInfoAdditionalDataForm form={form} padding={3} />}
                </SchemaFormHook>}
            </form.Subscribe>
        </Dialog>

        <Drawer code="addRubro">
            <ModalHeader>Agregar Rubro</ModalHeader>
            <AddRubroMutation>
                {mutation => <SchemaFormHook
                    schema={rubroFormSchema}
                    onSubmit={async ({ value }) => {
                        const rubro = await mutation.mutateAsync(value);
                        notify("Se a agregado el rubro correctamente");
                        form.setFieldValue("rubroId", rubro.id);
                    }}
                    closeModalOnSubmit
                    submitOnce
                >
                    {form => <RubroForm form={form} padding={3} />}
                </SchemaFormHook>}
            </AddRubroMutation>
        </Drawer>
    </Stack>
}

